export { LrsModule } from './core/lrs.module';
export { LrsService } from './core/lrs.service';
